<mat-checkbox
  [checked]="value"
  (click)="next()"
  [disabled]="disabled"
  [indeterminate]="value === null"
  [color]="value === null ? 'warn' : 'primary'"
>
  <ng-content></ng-content>
</mat-checkbox>
